import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_CALENDARS = gql`
query {
  getCalendar {
    id
    google_name
  }
}
`;

const getCalendars = async () => {
  try {
    const result = await client.query({
      query: GET_CALENDARS,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    });
    const data = result?.data?.getCalendar;
    return data || [];
  } catch (error) {
    console.log('Error:', error);
    return null;
  }
};

export default getCalendars;
